import {computed, defineComponent} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapSearch',
    props: {
        tagName: {
            type: String,
            default: 'div'
        },
        modOffset: Boolean
    },
    setup(props) {
        const classes = computed(() => {
            return [
                'kl-ol-map-search',
                {
                    'kl-ol-map-search--offset': props.modOffset
                }
            ]
        })
        return {
            classes
        }
    }
})
